import axios2 from '../api/axios';
export const CalculationServices = {
    getCalculations,  
    getshopifyconnection
}


function getCalculations(){
   return axios2.get(`/getCalculations`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function getshopifyconnection(){
   return axios2.get(`/shopify/getshopifyconnection`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}